"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
function SvgFlameOutline(props) {
    return (React.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 32 32" }, props),
        React.createElement("path", { d: "M22 10.85c-.41-.49-.82-1-1.18-1.45A27.08 27.08 0 0117 2.68l-.53-1.57-1.14 1.2C14.9 2.71 6 12.15 6 20a10 10 0 0020 0c0-4.4-2.23-7-4-9.15zm-9 14c0-2.06 1.79-4.77 3-6.31 1.09 1.32 3 4 3 6.31A3.08 3.08 0 0116 28a3.08 3.08 0 01-3-3.15zm7.73 1.59a5.3 5.3 0 00.27-1.59c0-4.05-4.1-8.36-4.28-8.54l-.72-.77-.72.78C15.09 16.51 11 21 11 24.85a5.3 5.3 0 00.27 1.59A8 8 0 018 20c0-5.56 5.38-12.45 7.69-15.15a33.13 33.13 0 003.51 5.75c.39.51.81 1 1.26 1.55C22.2 14.21 24 16.34 24 20a8 8 0 01-3.27 6.44z" })));
}
exports.default = SvgFlameOutline;
//# sourceMappingURL=FlameOutline.js.map